import type { AppLocale } from '@/i18n/locales'

export const orderCopy: Record<AppLocale, { experience: string; progress: string; pause: string; end: string }> = {
  'zh-CN': { experience: '经验效率', progress: '升级进度', pause: '暂停', end: '结束' },
  'zh-TW': { experience: '經驗效率', progress: '升級進度', pause: '暫停', end: '結束' },
  en: { experience: 'EXP rate', progress: 'Level progress', pause: 'Pause', end: 'End' },
  ja: { experience: '経験値効率', progress: 'レベル進捗', pause: '一時停止', end: '終了' },
  ko: { experience: '경험치 효율', progress: '레벨 진행률', pause: '일시 정지', end: '종료' },
}

export function orderBackground(theme: 'light' | 'dark'): string {
  return theme === 'dark' ? '#1b1d1f' : '#ffffff'
}

export { dailyPanelFits as orderContentFits, fitDailyPanel as fitOrderWidget } from './daily-panel'
